import { Component, ViewChild } from '@angular/core';
import { CaseService } from '../../../../../services/case.services';
import {
  ICaseStatusHistory,
  ICaseStatusLogs,
} from '../../../interfaces/case-card-interfaces';
import { CorePopupComponent } from '../../../../../../../ui-components/core-popup/core-popup.component';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';
import { VehicleLocationMapComponent } from '../../../../../../../shared/components/vehicle-location-map/vehicle-location-map.component';
import { WatchTeamMembersCardComponent } from '../../../../../../../shared/components/watch-team-members-card/watch-team-members-card.component';

@Component({
  selector: 'app-case-vehicle-status-timeline',
  templateUrl: './case-vehicle-status-timeline.component.html',
  styleUrl: './case-vehicle-status-timeline.component.scss',
})
export class CaseVehicleStatusTimelineComponent {
  @ViewChild('popup') popup: CorePopupComponent;
  @ViewChild('vehicleLocationMap')
  vehicleLocationMap: VehicleLocationMapComponent;

  @ViewChild('teamMembers')
  teamMembers: WatchTeamMembersCardComponent;

  activeTabIndex = 0;

  showPopup: boolean = false;
  vehicles: ICaseStatusLogs[] = [];
  userLogs: any[] = [];
  selectedLog: ICaseStatusHistory | null;

  showEditDates: boolean = false;
  selectedVehicle: ICaseStatusLogs | null;
  editDate: {
    statusStartDate: Date | null;
    statusEndDate: Date | null;
    statusDuration: number | null;
  };
  //eğer aynı anda birden fazla acordion acık istiyorsak
  //expandedIndices kullanıcaz sadece tek acordion acık istiyorsak expandedIndex kullanılmalı
  expandedIndex: number | null = 0;
  expandedIndices: number[] = [];
  constructor(
    private readonly caseService: CaseService,
    private readonly messageService: AppMessageService
  ) {}

  initilize(caseId: number, openTab?: 'vehicle' | 'user') {
  this.showPopup = true;
  this.selectedVehicle= null;
  this.expandedIndices = [];
  this.toggleAccordion(0);

  this.caseService.getStatusLogsByCase(caseId).subscribe({
    next: (res: any) => {
      this.vehicles = res.vehicleLogs ?? [];
      this.userLogs = res.userLogs ?? [];
      this.vehicles = res?.filter((v:any) => v.vehicleId !=null);
      // ✅ otomatik tab seçimi
      if (this.hasVehicles && this.hasUsers) {
        this.activeTabIndex = openTab === 'user' ? 1 : 0;
      } else {
        this.setDefaultTab();
      }
    },
  });
}

  toggleAccordion(index: number) {
    const isOpen = this.expandedIndices.includes(index);

    if (isOpen) {
      // kapat
      this.expandedIndices = this.expandedIndices.filter((i) => i !== index);
    } else {
      // aç
      this.expandedIndices.push(index);
    }
  }
  //  toggleAccordion(index: number): void {
  //     // Aynı indekse tekrar tıklanırsa kapansın, değilse yeni indeksi açsın.
  //     this.expandedIndex = this.expandedIndex === index ? -1 : index;
  //   }

  onShowTeam(vehicle: ICaseStatusLogs, index: number): void {
    console.log("EYYo")
    if (
      vehicle &&
      vehicle?.statusHistory?.length > 0 &&
      vehicle?.statusHistory[0]?.statusStartDate &&
      vehicle?.statusHistory[0]?.statusEndDate
    ) {
      // o statü tarihleri arasında nöbette olan çalışanlar tespit ediliyor
      this.teamMembers.initilize(vehicle.dot.dotName, {
        dotId: vehicle.dot.id,
        vehicleId: vehicle.vehicleId,
        startDate: vehicle.statusHistory[0].statusStartDate,
        endDate: vehicle.statusHistory[0].statusEndDate,
      });
    }
  }

  onShowRoute(vehicle: ICaseStatusLogs, index: number): void {
  this.selectedVehicle = vehicle;

  const firstLog =
    vehicle.statusHistory.length > 0
      ? vehicle.statusHistory[0]
      : null;

  const lastLog =
    vehicle.statusHistory.length > 0
      ? vehicle.statusHistory.at(-1)
      : null;

  this.vehicleLocationMap.selectedVehicle = vehicle.vehicleId;
  this.vehicleLocationMap.type = 'case-timeline';

  this.vehicleLocationMap.open({
    caseStatusTimeline:
      firstLog && lastLog
        ? {
            startDate: firstLog.statusStartDate,
            endDate:
              lastLog.statusEndDate ??
              lastLog.statusStartDate,
          }
        : null,
  });
  }

  parentPopupClose() {
    this.expandedIndex = 0;
    this.expandedIndices = [];
    this.selectedVehicle = null;
    this.selectedLog = null;
    this.showEditDates = false;
  }

  editLogStatusDate(status: ICaseStatusHistory) {
    this.selectedLog = status;
    this.editDate = {
      statusStartDate: this.selectedLog.statusStartDate
        ? new Date(this.selectedLog.statusStartDate)
        : null,
      statusEndDate: this.selectedLog.statusEndDate
        ? new Date(this.selectedLog.statusEndDate)
        : null,
      statusDuration: this.selectedLog.statusDuration,
    };
    this.calculateDuration();
    this.showEditDates = true;
    setTimeout(() => {
      this.popup.openDialog();
    }, 100);
  }

  calculateDuration() {
    if (this.editDate.statusEndDate && this.editDate.statusStartDate) {
      let diffMs = 0;
      if (this.editDate.statusStartDate && this.editDate.statusEndDate) {
        diffMs = this.editDate.statusEndDate.getTime() - this.editDate.statusStartDate.getTime();
      }
      this.editDate.statusDuration = Math.floor(diffMs / 60000); // 1000 ms * 60 = 1 dakika
    } else {
      this.editDate.statusDuration = null;
    }
  }
  closeDatePopup() {
    this.selectedLog = null;
    this.selectedVehicle = null;
    this.editDate = {
      statusDuration: null,
      statusEndDate: null,
      statusStartDate: null,
    };
  }
  updateDates() {
    if (this.selectedLog) {
      if (!this.editDate.statusStartDate || !this.editDate.statusEndDate) {
        this.messageService.warningToast(
          '',
          'Başlangıç Tarihi ve Bitiş Tarihinden boş olamaz.'
        );
        return;
      }
      if (this.editDate.statusDuration && this.editDate.statusDuration < 0) {
        this.messageService.warningToast(
          '',
          'Başlangıç Tarihi Bitiş Tarihinden büyük olamaz'
        );
        return;
      }

      this.caseService
        .updateStartEndDateLog(
          this.selectedLog?.id,
          this.editDate.statusStartDate,
          this.editDate.statusEndDate
        )
        .subscribe((res) => {
          if (res.success) {
            for (const v of this.vehicles) {
              const findElement = v.statusHistory.find(
                (i) => i.id === res.response.id
              );
              if (findElement) {
                findElement.statusStartDate = res.response.statusStartDate;
                findElement.statusEndDate = res.response.statusEndDate;
                findElement.statusDuration = res.response.statusDuration;
              }
            }
            this.messageService.successToast(
              'Başarılı',
              'Kayıt başarıyla güncellendi'
            );
            this.popup.closeDialog();
          }
        });
    }
  }

  get hasVehicles(): boolean {
    return (this.vehicles?.length ?? 0) > 0;
  }

  get hasUsers(): boolean {
    return (this.userLogs?.length ?? 0) > 0;
  }
  private setDefaultTab() {
    // sadece personel varsa -> personel
    if (!this.hasVehicles && this.hasUsers) {
      this.activeTabIndex = 0; // çünkü tek panel mode'a geçiyoruz (tab yok)
      return;
    }

    // sadece araç varsa -> araç
    if (this.hasVehicles && !this.hasUsers) {
      this.activeTabIndex = 0;
      return;
    }

    // ikisi de varsa default araç
    this.activeTabIndex = 0;
  }

}
